<mat-toolbar class="top-bar">
  <div class="toolbar-content">

    <div class="left-section">
      <div class="logo-block" routerLink="/">
        <img
          src="logo-inverse.png"
          alt="Wide & Heavy"
          class="logo"
          matTooltip="Wide & Heavy"
        />
      </div>

      <span class="app-title">
        {{ isMobile ? pageTitle : 'Wide & Heavy' }}
      </span>
    </div>

    <div class="right-section">

    @if (carrierConnectionCount === 0) {
      <div class="connection-warning">
        <button
          mat-icon-button
          matTooltip="Connect a carrier or broker to unlock posting and searching."
          (click)="openConnectionsInfo()"
        >
          <mat-icon class="connection-warning-icon">error_outline</mat-icon>
        </button>

        @if (!isMobile) {
          <span class="connection-warning-text">
            No carrier connections
          </span>
        }
      </div>
    }

      @if (!isCompactHeader) {
        <div class="nav-buttons">
          @for (route of navRoutes; track route) {
            <button
              mat-button
              [routerLink]="route.link"
              class="primary-button nav-route-button"
              [disabled]="isActive(route.link)"
              matTooltip="{{ route.title }}"
            >
              <mat-icon class="mr-1">{{ route.icon }}</mat-icon>
              {{ route.label }}
            </button>
          }
        </div>
      }

      <div class="user-section">
        @if(!isMobile) {
          <button
            mat-button
            class="primary-button"
            matTooltip="Menu"
            [matMenuTriggerFor]="isCompactHeader ? navMenu : settingsMenu"
          >
            <mat-icon class="mr-1">menu</mat-icon>
            Menu
          </button>
        } @else {
          <button
            mat-icon-button
            matTooltip="Menu"
            [matMenuTriggerFor]="isMobile ? navMenu : settingsMenu"
          >
            <mat-icon>menu</mat-icon>
          </button>
        }

        <mat-menu #navMenu="matMenu">
          @for (route of navRoutes; track route) {
            <button mat-menu-item [routerLink]="route.link" [disabled]="isActive(route.link)">
              <mat-icon>{{ route.icon }}</mat-icon>
              <span>{{ route.label }}</span>
            </button>
          }

          <mat-divider></mat-divider>

          @for (route of settingsRoutes; track route) {
            <button mat-menu-item [routerLink]="route.link" [disabled]="isActive(route.link)">
              <mat-icon>{{ route.icon }}</mat-icon>
              <span>{{ route.label }}</span>
            </button>
          }

          <button mat-menu-item (click)="openSupportDialog()">
            <mat-icon>support</mat-icon>
            <span>Support</span>
          </button>

          <button mat-menu-item (click)="logout()">
            <mat-icon>logout</mat-icon>
            <span>Log Out</span>
          </button>
        </mat-menu>

        <mat-menu #settingsMenu="matMenu">
          @for (route of settingsRoutes; track route) {
            <button mat-menu-item [routerLink]="route.link" [disabled]="isActive(route.link)">
              <mat-icon>{{ route.icon }}</mat-icon>
              <span>{{ route.label }}</span>
            </button>
          }

          <button mat-menu-item (click)="openSupportDialog()">
            <mat-icon>support</mat-icon>
            <span>Support</span>
          </button>

          <button mat-menu-item (click)="logout()">
            <mat-icon>logout</mat-icon>
            <span>Log Out</span>
          </button>
        </mat-menu>
      </div>

    </div>
  </div>
</mat-toolbar>